import { useFpCampaignCartCalculate } from '@cart-services/hooks/useFpCampaignCartCalculate'
import { useFpCampaignCouponService } from '@cart-services/hooks/useFpCampaignCouponService'
import { useFastpassCampaignGoogleAnalyticEvent } from '@dni-analysis'
import { useDialog } from '@dni-hooks/useDialog'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { Divider } from '@pets-ui/Divider/Divider'
import { Footer } from '@pets-ui/Footer/Footer'
import { FooterStack } from '@pets-ui/FooterStack/FooterStack'
import { HStack } from '@pets-ui/HStack/HStack'
import { IconButton } from '@pets-ui/IconButton/IconButton'
import { CartOutlined, GiftFilled } from '@pets-ui/icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import { useState } from 'react'
import { useHistory } from 'react-router-dom-v5'
import { ButtonCampaignFooterAmount } from '../../../../../components/ButtonCampaignFooterAmount/ButtonCampaignFooterAmount'
import { DIALOG_ORDER_DETAIL, DialogOrderDetail } from '../../../cart/components/DialogOrderDetail/DialogOrderDetail'
import { FooterCoupon } from '../../../cart/components/FooterCoupon/FooterCoupon'
import { DialogRegularGiveawayTips } from '../DialogRegularGiveawayTips/DialogRegularGiveawayTips'
import { FooterShippings } from '../FooterShippings/FooterShippings'
import { useProductCatalog } from '../ProductCatalogProvider/useProductCatalog'

export const ProductCatalogFooter = () => {
  const { cartTotalQuantity, countryCode, projectCode, currency, campaignId, campaignCode } = useProductCatalog()
  const { destructuredData: campaignCouponCalculateResult } = useFpCampaignCartCalculate(campaignId, campaignCode)
  const { sendBeginCartEvent } = useFastpassCampaignGoogleAnalyticEvent({ projectCode, countryCode, campaignId })
  const { regularGiveaways } = useFpCampaignCouponService(
    campaignId,
    countryCode,
    campaignCode,
  )
  const { total } = campaignCouponCalculateResult || {}
  const [isOpen, setIsOpen] = useState(false)
  const history = useHistory()
  const { openDialog: openDialogOrderDetail, closeDialog: closeDialogOrderDetail } = useDialog(DIALOG_ORDER_DETAIL)

  const handleCheckoutClick = async () => {
    history.push(`/campaigns/${campaignCode}/cart`)
    sendBeginCartEvent()
  }

  const handleDialogOrderDetailCheckout = () => {
    openDialogOrderDetail({
      handleCheckout: () => {
        handleCheckoutClick()
        closeDialogOrderDetail()
      },
      actionButtonText: '前往購物車',
    })
  }
  const handleDialogGiftOpen = () => setIsOpen(true)
  const handleDialogGiftClose = () => setIsOpen(false)

  return (
    <>
      <FooterStack
        renderTransparentFooters={() => (
          <FooterShippings
            totalAmount={campaignCouponCalculateResult?.total_after_discount}
            currency={currency}
            shippingMethods={campaignCouponCalculateResult?.shipping_methods}
            positionMode="absolute"
          />
        )}
      >
        <FooterCoupon
          projectCode={projectCode}
          countryCode={countryCode}
          campaignId={campaignId}
          campaignCode={campaignCode}
        />
        <Divider />
        <Footer elevation={0}>
          <HStack gap={2}>
            {(regularGiveaways?.length ?? 0) > 0 && (
              <IconButton onClick={handleDialogGiftOpen}>
                <VStack gap={0.5} alignItems="center">
                  <GiftFilled color={colors.grey800} />
                  <Text variant="caption" color={colors.grey800}>滿額禮</Text>
                </VStack>
              </IconButton>
            )}
            <ButtonCampaignFooterAmount amount={total} currency={currency} onClick={handleDialogOrderDetailCheckout} shippingFee={campaignCouponCalculateResult?.shipping_total || 0} />
          </HStack>
          <Box flexGrow={1} />
          <HStack gap={2}>
            <Button
              startIcon={<CartOutlined />}
              onClick={handleCheckoutClick}
              disabled={cartTotalQuantity === 0}
              data-testid="button-product-catalog-go-next"
            >
              (
              {cartTotalQuantity.toLocaleString()}
              )
            </Button>
          </HStack>
        </Footer>
      </FooterStack>
      <DialogRegularGiveawayTips open={isOpen} onClose={handleDialogGiftClose} />
      <DialogOrderDetail />
    </>
  )
}
